import React from 'react';
import { Table } from 'antd';
import {formatDateTime} from "@utils/helpers/formatDate";


const columns = [
  {
    title: 'No',
    dataIndex: 'no',
    key: 'no'
  },
  {
    title: 'Seller Name',
    dataIndex: 'name',
    key: 'name'
  },
  {
    title: 'Product Name',
    dataIndex: 'productName',
    key: 'productName'
  },
  {
    title: 'SKU',
    dataIndex: 'sku',
    key: 'sku'
  },
  {
    title: 'Quantity',
    dataIndex: 'quantity',
    key: 'quantity'
  },
  {
    title: 'Return / Disposal',
    dataIndex: 'processType',
    key: 'processType',
    render: (value: string) => {
      return value?.charAt(0)?.toUpperCase() + value?.slice(1);
    }
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status'
  },
  {
    title: 'Update Date',
    render: (record: any) => {
      return formatDateTime(record.updatedAt)
    }
  }
];

interface IProps {
  loading: boolean;
  getReturns: Function;
  totalReturns: number;
  returnsRowData: any;
  selectedReturns: React.Key[];
  setSelectedReturns: React.Dispatch<React.SetStateAction<React.Key[]>>;
}
const ReturnDisposalListTable = ({
  loading,
  getReturns,
  totalReturns,
  returnsRowData,
  selectedReturns,
  setSelectedReturns
}: IProps) => {

  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedReturns(newSelectedRowKeys);
  };
  const rowSelection = {
    selectedReturns,
    onChange: onSelectChange
  };

  return (
    <div>
      <Table
        className="busk-table"
        rowSelection={rowSelection}
        loading={loading}
        columns={columns}
        dataSource={returnsRowData}
        pagination={{
          pageSize: 10,
          total: totalReturns
        }}
      />
    </div>
  );
}

export default ReturnDisposalListTable;